var exports = {
  "Kk": "GuildMemberActionsSheet.module__icon___UDN2dk",
  "wx": "GuildMemberActionsSheet.module__header___UDN2dk",
  "Se": "GuildMemberActionsSheet.module__headerInfo___UDN2dk",
  "Bv": "GuildMemberActionsSheet.module__headerName___UDN2dk",
  "sD": "GuildMemberActionsSheet.module__headerTag___UDN2dk",
  "im": "GuildMemberActionsSheet.module__headerAvatarImg___UDN2dk",
};

module.exports = exports;
